import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { ArrowRight, ArrowLeft } from 'lucide-react';

export default function EstimationStep3({ formData, errors, updateFormData, onNext, onBack }) {
  return (
    <div data-testid="estimation-step-3">
      <h2 className="text-2xl font-semibold text-[#2B2B2B] mb-6">
        Où se situe votre bien ?
      </h2>

      <div className="space-y-6">
        <div>
          <Label htmlFor="address">Adresse *</Label>
          <Input
            id="address"
            value={formData.address}
            onChange={(e) => updateFormData('address', e.target.value)}
            placeholder="Rue et numéro"
            data-testid="estimation-address"
          />
          {errors.address && <p className="text-sm text-red-500 mt-1">{errors.address}</p>}
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label htmlFor="postal_code">Code postal *</Label>
            <Input
              id="postal_code"
              value={formData.postal_code}
              onChange={(e) => updateFormData('postal_code', e.target.value)}
              placeholder="Ex: 1200"
              data-testid="estimation-postal-code"
            />
            {errors.postal_code && <p className="text-sm text-red-500 mt-1">{errors.postal_code}</p>}
          </div>

          <div>
            <Label htmlFor="city_full">Ville *</Label>
            <Input
              id="city_full"
              value={formData.city_full}
              onChange={(e) => updateFormData('city_full', e.target.value)}
              placeholder="Ex: Genève"
              data-testid="estimation-city-full"
            />
            {errors.city_full && <p className="text-sm text-red-500 mt-1">{errors.city_full}</p>}
          </div>
        </div>
      </div>

      <div className="flex gap-4 mt-8">
        <Button
          onClick={onBack}
          variant="outline"
          className="flex-1"
          data-testid="estimation-back-3"
        >
          <ArrowLeft className="mr-2 h-4 w-4" /> Retour
        </Button>
        <Button
          onClick={onNext}
          className="flex-1 bg-[#8A9474] hover:bg-[#7A8464] text-white"
          data-testid="estimation-next-3"
        >
          Continuer <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
